export var getLinkFieldOrNull = function getLinkFieldOrNull(linkField) {
  var _linkField$value;
  if (linkField && linkField !== null && linkField !== void 0 && linkField.value && !(linkField !== null && linkField !== void 0 && (_linkField$value = linkField.value) !== null && _linkField$value !== void 0 && _linkField$value.href)) {
    return null;
  }
  return linkField;
};